import { Controller } from 'stimulus';

export default class VideoIllustrationController extends Controller {
  static targets = ['video'];

  hovered = false;

  playing = false;

  connect() {
    this.element.addEventListener('mouseenter', this.onHover);
    this.element.addEventListener('mouseleave', this.onBlur);
    this.videoTarget.addEventListener('ended', this.onEndPlayback);
    this.videoTarget.addEventListener('loadedmetadata', this.loadedMetaData);
    this.element.addEventListener('touchstart', this.onHover);
    document.documentElement.addEventListener('touchend', this.onBlur);
  }

  disconnect() {
    this.element.removeEventListener('mouseenter', this.onHover);
    this.element.removeEventListener('mouseleave', this.onBlur);
    this.videoTarget.removeEventListener('ended', this.onEndPlayback);
    this.videoTarget.removeEventListener('loadedmetadata', this.loadedMetaData);
    this.element.removeEventListener('touchstart', this.onHover);
    document.documentElement.removeEventListener('touchend', this.onBlur);
  }

  reset() {
    this.videoTarget.pause();
    this.videoTarget.currentTime = 0;
  }

  play() {
    if (this.playing) {
      return;
    }

    this.playing = true;
    this.videoTarget.play();
  }

  onHover = () => {
    if (this.videoTarget.readyState < 3) {
      return;
    }

    this.hovered = true;
    this.play();
  };

  onBlur = () => {
    this.hovered = false;
  };

  onEndPlayback = () => {
    this.playing = false;
    this.reset();

    if (this.hovered) {
      this.play();
    }
  };

  // Fix for the iOS Safari: play and pause immediately in order to show the first frame
  // of the video
  loadedMetaData = () => {
    this.videoTarget.play();
    this.videoTarget.pause();
  };
}
